import * as Sentry from '@sentry/react'
import { createFileRoute, redirect } from '@tanstack/react-router'

import { AuthLayout } from '@/components/authLayout/AuthLayout'
import {
  getUserId,
  isAuthUserAuthenticated,
  isUserCloudWorker,
} from '@/stores/authUser.store'
import {
  WORK_MODE_DEFAULT_PATH,
  getLastActiveMode,
} from '@/stores/userMode.store'
import { isWorkModeRestrictedPath, resolveAppMode } from '@/utils/appMode'

export const Route = createFileRoute('/_auth')({
  beforeLoad: ({ location }) => {
    if (!isAuthUserAuthenticated()) {
      throw redirect({
        to: '/login',
        replace: true,
        state: isUserCloudWorker()
          ? undefined
          : {
              redirectTo: {
                pathname: location.pathname,
                search: location.searchStr,
              },
            },
      })
    }

    Sentry.setUser({
      id: getUserId() ?? undefined,
    })

    const isCloudWorker = isUserCloudWorker()
    const modeBasedOnUrl = resolveAppMode({
      pathname: location.pathname,
      isCloudWorker,
      lastActiveMode: getLastActiveMode(),
    })

    if (
      isWorkModeRestrictedPath({
        mode: modeBasedOnUrl,
        pathname: location.pathname,
        isCloudWorker,
      })
    ) {
      throw redirect({
        to: WORK_MODE_DEFAULT_PATH,
        replace: true,
      })
    }
  },
  component: AuthLayout,
  loader: () => ({ breadcrumbTitle: 'Home' }),
})
